<template>
  <v-dialog width="350px" persistent v-model="editDialog" class="editDialogsRow">
    <v-card-text class="pa-0" slot="activator">
      Add Indication
      <v-icon class="text-xs-right">add</v-icon>
    </v-card-text>
    <v-card>
      <v-container>
        <v-layout justify-end row wrap>
          <v-flex xs1 class="mb-2">
            <v-icon depressed class="cyan--text text--lighten-1" @click="editDialog = false">close</v-icon>
          </v-flex>
          <v-flex xs12 class="mb-2">
            <v-card-title class="text-xs-center justify-center"><h2>Edit {{ trial.trialName }} Indications</h2></v-card-title>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12 v-for="item in editedIndications" v-bind:key="item.objectName">
            {{item.name}}
          </v-flex>
          <v-flex xs12 class="text-xs-center">
            <v-card-text>
              <h3>Current Indications:</h3>
              <div v-for="item in indicationsss" v-bind:key="item.indicationID">
                {{ item.indicationName }}
              </div>
            <!--<v-select
              :items="editedIndications"
              v-model="holder"
              item-value="name"
              label="Indication"
              multiple-line
              bottom
              multiple
            ></v-select> -->
            <v-select
                name="trial.trialIndications"
                label="Add Trial Indications"
                :items="indications"
                item-value="indicationId"
                item-text="indicationName"
                v-model="editedIndications"
                id="trial.trialIndications"
                multiple
                max-height="400"
                hint="Pick your indications"
                persistent-hint
              ></v-select>             
            </v-card-text>
            <v-btn depressed class="grey white--text" to="/indication/new">Create New Indication</v-btn>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions class="justify-center">
              <v-btn depressed class="grey lighten-1 white--text" @click="editDialog = false">Cancel</v-btn>
              <v-btn depressed class="white--text cyan " @click="onSaveChanges">Save</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['trial'],
  data () {
    return {
      editDialog: false,
      editedIndications: this.trial.trialIndications,
      trialIndications: [],
      holder: []
    }
  },
  computed: {
    indications () {
      return this.$store.getters.loadedIndications
    },
    loadIndications () {
      return this.$store.getters.loadedTrials
    },
    indicationsss () {
      if (this.trial.trialIndications) {
        var indis = []
        var val = []
        // var item = []
        this.trial.trialIndications.filter(function (elem) {
          indis.push(elem)
        })
        console.log('Indication IDs: ' + JSON.stringify(indis))
        for (let i = 0; i < indis.length; i++) {
          console.log('SECOND GET INDIS: ' + JSON.stringify(this.$store.getters.loadedIndication(indis[i])))
          if (this.$store.getters.loadedIndication(indis[i])) {
            val.push(this.$store.getters.loadedIndication(indis[i]))
          }
        }
        console.log('FINAL val: ' + JSON.stringify(val))
        return val
      } else {
        return null
      }
    }
  },
  methods: {
    onSaveChanges () {
      this.trialIndications = this.editedIndications
      this.editDialog = false
      console.log('edit page: ' + this.trialIndications)
      this.$store.dispatch('updateTrialData', {
        trialId: this.trial.trialId,
        trialIndications: this.trialIndications
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// EditTrialIndicationsDialog.vue?2a060d81